import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { dataActions } from "../store/data-slice";
import { screenActions } from "../store/screens-slice";

import ScrollMenu from "react-horizontal-scrolling-menu";
import "./Months.css";

import { ENVIRONMENT } from "../constans";
import { useTranslation } from "react-i18next";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

//Detect if the user is using a mobile device
const detectIsMobile = () => {
  var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    return true;
  } else {
    return false;
  }
};

//Toggle the selected month class, change the background color to blue when it's active by adding its class
const MenuItem = ({ text, selected }) => {
  return <div className={`menu-item ${selected ? "active" : ""}`}>{text}</div>;
};

//Loop through the months list and print it, Enero, Febrero, Marzo... etc.
export const createMonthSlider = (list, selected) =>
  list.map((item) => {
    return (
      <MenuItem
        text={item.month.name}
        key={item.month.name}
        selected={selected}
      />
    );
  });

const Arrow = ({ icon, className }) => {
  return (
    <div className={className}>
      {icon === "<" ? <ArrowBackIosIcon /> : <ArrowForwardIosIcon />}
    </div>
  );
};

//If the user is not using the mobile device, show the left and right arrows
const ArrowLeft = !detectIsMobile()
  ? Arrow({ icon: "<", className: "arrow-prev" })
  : false;
const ArrowRight = !detectIsMobile()
  ? Arrow({ icon: ">", className: "arrow-next" })
  : false;

const groupDataByMonth = (cursos, t) => {
  let months = [];
  for (const [key, value] of Object.entries(cursos)) {
    let year = parseInt(key.substring(2, 6));
    let month_num = parseInt(key.substring(0, 2));
    months.push({
      month: {
        id: month_num,
        name: t(`MONTHS.months_list.${month_num}`),
        year,
        value,
      },
    });
  }
  return months;
};

const Months = () => {
  const [selected, setselected] = useState();
  const [menu, setmenu] = useState([]);
  const [calendarios, setCalendarios] = useState([]);
  const disableClass = useSelector((state) => state.toggle.disable);

  const [t] = useTranslation("global");

  const dispatch = useDispatch();

  useEffect(() => {
    fetchData();
  }, []);

  //Fetch fechas from the server and get the result
  const fetchData = async () => {
    try {
      let domain;
      if (ENVIRONMENT === "development") {
        domain = "http://localhost:7000";
        console.warn("=== dev mode ===>", domain);
      } else {
        console.warn("=== app running in prod mode ===");
        domain = "https://reservas.escolaportbarcelona.com/api";
      }

      const dataPracticas = await fetch(`${domain}/get_practicas_ln`, {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      const dataTeoria = await fetch(`${domain}/get_teorias_ln`, {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      const dataResumen = await fetch(`${domain}/get_url_reserva_ln`, {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      // We only check the status of the Practicas request, if it's ok, we continue
      let { status } = dataPracticas;

      if (status === 200) {
        //!Prácticas
        //If there's no practices Backend answer is a string or an empty object
        let result_practicas = await dataPracticas.json();
        if (typeof result_practicas === "string") {
          result_practicas = {};
        }

        //!Teoría
        const result_teoria = await dataTeoria.json();
        //!Resumen
        const result_resumen = await dataResumen.json();

        //Get a new array converted data with all the informations
        let calendarios_data_practicas = groupDataByMonth(result_practicas, t);

        //Sort array by month-year by creating a date out of strings and sorting them acccordingly:
        calendarios_data_practicas = calendarios_data_practicas.sort(
          (a, b) =>
            new Date(a.month.year, a.month.id, 1) -
            new Date(b.month.year, b.month.id, 1)
        );

        //Print the months list
        setmenu(createMonthSlider(calendarios_data_practicas, selected));

        setCalendarios(calendarios_data_practicas);

        if (calendarios_data_practicas.length > 0) {
          dispatch(dataActions.applyDataPracticas(calendarios_data_practicas));
        }

        //Select the first month of the array and set it as the first displayed month on the screen
        //so if 072022 is the first date on the api json file
        //the first month will be selected on the screen is Julio
        calendarios_data_practicas.forEach((e) => {
          let month = calendarios_data_practicas[0].month.name;

          setselected(month);
        });

        dispatch(dataActions.applyDataTeoria(result_teoria));
        dispatch(dataActions.setResumenData(result_resumen));
        dispatch(dataActions.setDataPracticasLoading(false));
      } else {
        dispatch(dataActions.setDataPracticasLoading(false));
        dispatch(screenActions.setMainScreen("errorscreen"));
      }
    } catch (e) {
      dispatch(dataActions.setDataPracticasLoading(false));
      dispatch(screenActions.setMainScreen("errorscreen"));
    }
  };

  //The selected month's name (key) changes everytime a new month is been selected
  const onSelect = (key) => {
    setselected(key);
    dispatch(screenActions.setMonthSelected(key));
    dispatch(screenActions.setScrollDivPracticas(""));
  };

  return (
    <div
      className={
        disableClass //Disable the months list when one of the dates (fechas) is already been selected
          ? "months__container element__disable"
          : "months__container"
      }
    >
      {/* Print the months list and if there's more than 2 months show the arrows */}
      <ScrollMenu
        data={menu}
        arrowLeft={calendarios.length <= 2 ? false : ArrowLeft}
        arrowRight={calendarios.length <= 2 ? false : ArrowRight}
        selected={selected}
        onSelect={onSelect}
        translate={1}
      />
    </div>
  );
};

export default Months;
